/* eslint-disable */
import React from 'react';
import _ from 'lodash';

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const required = value => (value ? undefined : 'Required');

const maxLength = max => value =>
    value && value.length > max
        ? `Must be ${max} characters or less`
        : undefined;

const minLength = min => value =>
    value && value.length < min
        ? `Must be ${min} characters or less`
        : undefined;

const number = value =>
    value && isNaN(Number(value)) ? 'Must be a number' : undefined;

const minValue = min => value =>
    value && value < min ? `Must be at least ${min}` : undefined;

const minValue0 = minValue(0);

const maxValue = max => value =>
    value && value > max ? `Must Not be Greater than ${max}` : undefined;

const maxValue23 = maxValue(23);

const email = value =>
    EMAIL_REGEX.test(value) ? undefined : 'Email is invalid';

const mustMatch = (field, fieldName, compareFieldName) => (
    value,
    allValues
) => {
    const data = allValues.toJS();
    return !_.isEmpty(data) && data[field] === value
        ? undefined
        : 'Fields Must Match';
};

const errorToFields = (data = {}) => {
    const errors = {};
    if (data) {
        _.forEach(data.errors, error => {
            const key = error.source.pointer.replace('/data/attributes/', '');
            const fieldName = _.upperFirst(key.replace('_', ' '));
            errors[key] = `${fieldName} ${error.detail}`;
        });
    }
    return errors;
};

const nullToBlank = obj => {
    let returnObj = {};
    for (let field in obj) {
        if (typeof obj[field] === 'object' && obj[field] !== null) {
            returnObj[field] = nullToBlank(obj[field]);
        } else {
            if (obj[field] === null) {
                returnObj[field] = '';
            } else {
                returnObj[field] = obj[field];
            }
        }
    }

    return returnObj;
};

const removeBlankKeys = obj => {
    let returnObj = {};

    for (let field in obj) {
        if (obj[field] !== '') {
            returnObj[field] = obj[field];
        }
    }

    return returnObj;
}

const isEmpty = (obj) => {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

export {
    nullToBlank,
    removeBlankKeys,
    isEmpty,
    
    errorToFields,
    maxValue,
    minValue0,
    maxValue23,
    maxLength,
    minValue,
    number,
    required,
    email,
    mustMatch,
};


// WEBPACK FOOTER //
// ./src/utils/validations.js